import type { Nullable } from "../../../typescript"

interface HasIndex {
  index: number
}

export default function isIndexListSame(
  list1 : Nullable<Array<HasIndex>>,
  list2 : Nullable<Array<HasIndex>>
) : boolean {
  // If either array is null or they are of different lengths, return false.
  if (!list1 || !list2 || list1.length !== list2.length) {
    return false
  }

  // Check if every id in list1 matches the corresponding id in list2.
  // if the arrays are the same length but not the same list of ents,
  // then the last item is more likely to be different
  // and the first items are more likely to be the same.
  for (let i = list1.length - 1; i >= 0; i--) {
    if (list1[i].index !== list2[i].index) {
      return false;
    }
  }
  return true
}